module.exports = __webpack_public_path__ + "img/c5.810d0886.png";